import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineLockRotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M5.637 10.363v-2.1c0-.29.236-.525.525-.525h3.675c.29 0 .526.235.526.525v2.1c0 .29-.236.524-.526.524H6.162a.525.525 0 0 1-.525-.524" />
      <path d="M6.425 7.738v-1.05a1.575 1.575 0 1 1 3.15 0v1.05" />
      <path d="M14.302 5.375A6.827 6.827 0 0 0 1.175 8a6.825 6.825 0 0 0 13.468 1.575" />
      <path d="M14.825 2.75v2.625H12.2" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineLockRotation;
